var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasIncompleteSteps)?_c('div',{staticClass:"onboarding-status"},[_c('StepsList',{attrs:{"home-mode":true,"compact-mode":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }